"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateFns = require("date-fns");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dateFormat = 'MM/DD/YYYY';
function OwnedLicenseRenew(row) {
  var sourceEntity = row.sourceEntity,
    sourceType = row.sourceType,
    targetEntity = row.targetEntity;
  if (sourceEntity && targetEntity) {
    switch (sourceType) {
      case 'Cccisd\\Licensing\\Models\\HeldLicense':
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " renewed license using available license from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity));
      case 'Cccisd\\Licensing\\Models\\Voucher':
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " renewed license using voucher code ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity));
      default:
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " renewed license");
    }
  }
  if (targetEntity) {
    var oldExpiration = (0, _get2["default"])(row, 'metadata.old.expires_at');
    var newExpiration = (0, _get2["default"])(row, 'metadata.new.expires_at');
    if (oldExpiration && newExpiration) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Admin changed license expiration for ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " from", ' ', (0, _dateFns.format)(new Date(oldExpiration), dateFormat), " to ", (0, _dateFns.format)(new Date(newExpiration), dateFormat));
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin renewed license for ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (sourceEntity) {
    switch (sourceType) {
      case 'Cccisd\\Licensing\\Models\\HeldLicense':
        return /*#__PURE__*/_react["default"].createElement("span", null, "Available license from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " was used to renew license of an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
      case 'Cccisd\\Licensing\\Models\\Voucher':
        return /*#__PURE__*/_react["default"].createElement("span", null, "Voucher code ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " was used to renew license of an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
      default:
        return /*#__PURE__*/_react["default"].createElement("span", null, "Renewed license of an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
    }
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Admin renewed license of an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
}
var _default = exports["default"] = OwnedLicenseRenew;